export default "__VITE_ASSET__f86918ac__"